import io from "socket.io-client";

const socket = io.connect("https://latte-real-time-updates-dwr7snkjfq-ew.a.run.app");

export default socket;